module.exports = ".success--alert {\n  border-color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forgot-password/forgot-password.component.scss
// module id = ./src/app/forgot-password/forgot-password.component.scss
// module chunks = main